import React from 'react';
import { useSelector } from 'react-redux';
import {
  Route,
  Navigate,
  useLocation,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import DashboardContentLayout from '@layouts/DashboardContentLayout/DashboardContentLayout';
import DashboardLayout from '@layouts/DashboardLayout/DashboardLayout';
import InitLayout from '@layouts/InitLayout/InitLayout';
import { TokenInfo } from '@models/user';
// import RealTimeChargingStationMonitoring from '@pages/Equipment/RealTimeStationGun/RealTimeChargingStationMonitoring/RealTimeChargingStationMonitoring';
import RealTimePileDetail from '@pages/Equipment/RealTimeStationGun/RealTimePileDetail/RealTimePileDetail';
import RealTimeStationDetail from '@pages/Equipment/RealTimeStationGun/RealTimeStationDetail/RealTimeStationDetail';
import Home from '@pages/Home/Home';
import Login from '@pages/Login/Login';
import { IRootState } from '@store/reducers';
import { jwtDecode } from 'jwt-decode';

function PublicRoute(props: { children: any }) {
  const token = useSelector((state: IRootState) => state.userSlice.accessToken);

  if (token) {
    return <Navigate to="/" />;
  }

  const { children } = props;
  return children;
}

function PrivateRoute(props: { children: any }) {
  const token = useSelector((state: IRootState) => state.userSlice.accessToken);
  const { pathname } = useLocation();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (pathname === '/') {
    return <Navigate to="/home" />;
  }
  const { children } = props;
  return children;
}

function initUserData() {
  const accessToken = localStorage.getItem('accessToken') || '';
  const sellerId = Number(localStorage.getItem('sellerId'));
  const userId = Number(localStorage.getItem('userId'));
  const name = localStorage.getItem('name');
  const permissionList = localStorage.getItem('permissionList') || '';
  if (
    !accessToken ||
    sellerId === null ||
    userId === null ||
    !name ||
    !permissionList
  ) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('sellerId');
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    localStorage.removeItem('permissionList');
    return null;
  }

  const { type, account, userName } = jwtDecode(accessToken) as TokenInfo;
  return {
    accessToken,
    sellerId,
    userId,
    name,
    permissionList: JSON.parse(permissionList),
    type,
    account,
    userName,
  };
}

function getRouter() {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route element={<InitLayout />} loader={initUserData}>
        {/* PublicRoute 意思是不需權限 or token 就能進入 */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* PrivateRoute 意思是需要權限 or token 才能進入 */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              {/* 放側邊菜單的地方 */}
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          {/* 首頁比較特別，因為 path 是一層 /home，且此路由不在頁面階層設定 */}
          <Route path="home" element={<Home />} />

          {/* 有三層的 path 都要建立在頁面階層設定，才會出現在菜單裡 */}
          <Route
            path=":levelOne/:levelTwo/:levelThree"
            element={<DashboardContentLayout />}
          />

          {/* 以下 path 是沒有建立在頁面階層設定，也不會出現在菜單裡，所以暫時在這特地寫上屬於他們的 path，未來頁面階層改架構後，這邊可以視情況更改 */}
          <Route
            path="/Equipment/RealTimeStationGun/RealTimeChargingStationMonitoring/:id"
            element={<RealTimeStationDetail />}
          />
          <Route
            path="/Equipment/RealTimeStationGun/RealTimeChargingStationMonitoring/:stationId/:pileId"
            element={<RealTimePileDetail />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/home" />} />
      </Route>,
    ),
  );
}

export default getRouter;
